import React from "react";
import { RightArrowIcon } from "../../styles/img/svg/RightArrowIcon";
import { UiRoundedLogo } from "./UiRoundedLogo";

export const UiFavouriteBillCard = (props) => {
  return (
    <>
      <div
        className="df-fav-item df-fav-itm-card"
        onClick={props?.handleOnclick}
      >
        <div className="df-fav-item__logo">
          <UiRoundedLogo logo={props?.logo} />
        </div>

        <div className="df-fav-item__title">
          <h4>{props?.title}</h4>
          <p>{props?.description}</p>
        </div>

        <RightArrowIcon />
      </div>
    </>
  );
};
